export default "__VITE_ASSET__DNuem5pc__"